({ __webpack_nonce__ } = window);
